import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["valid"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import moment from "moment";
import { request } from "@/js/http/http_request.js";
import { isAddressNotLimited } from "@/js/http/auth.js";
import { getErrorData, handleErrorData, ERROR_DATA, filterVAutocomplete } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { filterIntegerKey } from "@/js/events/keycodes.js";
import { STOCK_TRANSFER_DOMESTIC } from "@/js/lists.ts";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var defaultEntityAddForm = {
  fromStockId: null,
  quantity: 0,
  toWarehouseId: null,
  reference: "",
  stockTransferDomesticId: null,
  comment: "",
  isImmediateTransfer: false,
  valid: false
};
export default {
  name: "StockTransferDomesticNewPartFormModal",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object,
    stockId: Number,
    fromWarehouseId: Number,
    wineName: String,
    quantityAvailable: Number
  },
  data: function data() {
    return {
      dialog: false,
      gettingWarehouses: {
        isPending: false,
        cancellationToken: null,
        items: [],
        itemsForDestination: []
      },
      gettingPendingTransfers: {
        isPending: false,
        cancellationToken: null,
        items: []
      },
      addingEntity: {
        form: _objectSpread({}, defaultEntityAddForm),
        isPending: false,
        cancellationToken: null
      },
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isLoading: function isLoading() {
      return this.gettingWarehouses.isPending;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.isLoading || this.addingEntity.isPending;
    },
    fromWarehouseName: function fromWarehouseName() {
      var _this$gettingWarehous,
        _this2 = this;
      return (_this$gettingWarehous = this.gettingWarehouses.items) === null || _this$gettingWarehous === void 0 || (_this$gettingWarehous = _this$gettingWarehous.find(function (x) {
        return x.id_warehouse === _this2.fromWarehouseId;
      })) === null || _this$gettingWarehous === void 0 ? void 0 : _this$gettingWarehous.name;
    }
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this3.getWarehouses();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    confirmNewPendingTransfer: function confirmNewPendingTransfer() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this4.$refs.confirm.open("Initiate pending transfer", "The stock quantity will be immediately available in the destination warehouse, marked as 'Pre-arrival'. Once the transfer is complete, you must mark it as done in the pending transfers interface. Are you sure you want to initiate this transfer ?", {
                color: "red"
              });
            case 2:
              ok = _context2.sent;
              if (ok) _this4.initiateNewPendingTransfer();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    initiateNewPendingTransfer: function initiateNewPendingTransfer() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this5.addingEntity.form.isImmediateTransfer = false;
              _this5.saveNewEntity(true);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    confirmNewImmediateTransfer: function confirmNewImmediateTransfer() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this6.$refs.confirm.open("Apply immediate transfer", "The stock quantity will be immediately marked as store in the destination warehouse. Are you sure you want to create this immediate transfer ?", {
                color: "red"
              });
            case 2:
              ok = _context4.sent;
              if (ok) _this6.createNewImmediateTransfer();
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    createNewImmediateTransfer: function createNewImmediateTransfer() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this7.addingEntity.form.isImmediateTransfer = true;
              _this7.saveNewEntity(true);
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    addPartToPendingTransfer: function addPartToPendingTransfer() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this8.addingEntity.form.isImmediateTransfer = false;
              _this8.saveNewEntity(false);
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    saveNewEntity: function saveNewEntity(isCreatingNewTransfer) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this9$addingEntity$c;
        var _this, _this9$addingEntity$f, valid, withoutValid;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this9.addingEntity.isPending = true;
              (_this9$addingEntity$c = _this9.addingEntity.cancellationToken) === null || _this9$addingEntity$c === void 0 || _this9$addingEntity$c.cancel();
              _this9.addingEntity.cancellationToken = axios.CancelToken.source();
              _this = _this9;
              _this9$addingEntity$f = _this9.addingEntity.form, valid = _this9$addingEntity$f.valid, withoutValid = _objectWithoutProperties(_this9$addingEntity$f, _excluded);
              withoutValid.fromStockId = _this9.stockId;
              _context8.next = 8;
              return request("/v1/stock-transfer-domestics", "post", withoutValid, true, "api", null, _this.addingEntity.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.addingEntity.isPending = false;
                          _this.addingEntity.cancellationToken = null;
                          errorData = getErrorData(e, _this.managedExceptions, isCreatingNewTransfer ? "Unable to create the transfer" : "Unable to add to pending transfer", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 8:
              _this9.addingEntity.isPending = false;
              _this9.addingEntity.cancellationToken = null;
              _this9.$toasted.show(isCreatingNewTransfer ? "New transfer created" : "Added to the pending transfer", {
                type: "success"
              });
              _this9.$emit("entityCreated");
              _this9.close();
            case 13:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    getWarehouses: function getWarehouses() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this10$gettingWareho;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this10.gettingWarehouses.isPending = true;
              (_this10$gettingWareho = _this10.gettingWarehouses.cancellationToken) === null || _this10$gettingWareho === void 0 || _this10$gettingWareho.cancel();
              _this10.gettingWarehouses.cancellationToken = axios.CancelToken.source();
              _this = _this10;
              _context9.next = 6;
              return request("/v1/warehouses", "post", {
                paging: null,
                allowDeleted: false
              }, true, "api", null, _this.gettingWarehouses.cancellationToken).catch(function (e) {
                _this.gettingWarehouses.isPending = false;
                _this.gettingWarehouses.cancellationToken = null;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get warehouses", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 6:
              response = _context9.sent;
              _this10.gettingWarehouses.items = _toConsumableArray(response.data.warehouses);
              _this10.gettingWarehouses.itemsForDestination = _toConsumableArray(response.data.warehouses.filter(function (x) {
                var _x$address, _x$address2;
                return x.id_warehouse != _this10.fromWarehouseId && isAddressNotLimited(_this10.loggedUserData, (_x$address = x.address) === null || _x$address === void 0 || (_x$address = _x$address.country) === null || _x$address === void 0 ? void 0 : _x$address.id_country, (_x$address2 = x.address) === null || _x$address2 === void 0 || (_x$address2 = _x$address2.state) === null || _x$address2 === void 0 ? void 0 : _x$address2.id_state);
              }));
              _this10.gettingWarehouses.isPending = false;
              _this10.gettingWarehouses.cancellationToken = null;
            case 11:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    changeDestinationWarehouse: function changeDestinationWarehouse() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this11.gettingPendingTransfers.items = [];
              _this11.addingEntity.form.stockTransferDomesticId = null;
              if (_this11.addingEntity.form.toWarehouseId > 0) {
                _this11.getPendingStockTransferDomestics();
              }
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    getPendingStockTransferDomestics: function getPendingStockTransferDomestics() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this12$gettingPendin;
        var data, paramsQuery, _this, response;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this12.gettingPendingTransfers.isPending = true;
              (_this12$gettingPendin = _this12.gettingPendingTransfers.cancellationToken) === null || _this12$gettingPendin === void 0 || _this12$gettingPendin.cancel();
              _this12.gettingPendingTransfers.cancellationToken = axios.CancelToken.source();
              data = {
                allowedStatus: [STOCK_TRANSFER_DOMESTIC.STATUS.PENDING.id],
                fromWarehouseIds: [_this12.fromWarehouseId],
                toWarehouseIds: [_this12.addingEntity.form.toWarehouseId]
              };
              paramsQuery = Object.encodeToUri(data);
              _this = _this12;
              _context11.next = 8;
              return request("/v1/stock-transfer-domestics?params=".concat(paramsQuery), "get", null, true, "api", null, _this.gettingPendingTransfers.cancellationToken).catch(function (e) {
                _this.gettingPendingTransfers.isPending = false;
                _this.gettingPendingTransfers.cancellationToken = null;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get pending transfers", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 8:
              response = _context11.sent;
              _this12.gettingPendingTransfers.items = _toConsumableArray(response.data.value.items);
              _this12.gettingPendingTransfers.items = response.data.value.items.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  displayName: "".concat(item.reference, " | ").concat(moment(item.creationDate).format("YYYY-MM-DD"))
                });
              });
              _this12.gettingPendingTransfers.isPending = false;
              _this12.gettingPendingTransfers.cancellationToken = null;
            case 13:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    changePendingTransfer: function changePendingTransfer() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (_this13.addingEntity.form.stockTransferDomesticId > 0) {
                _this13.addingEntity.form.reference = "";
                _this13.addingEntity.comment = "";
              }
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    open: function open() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this14.resetData();
              _this14.dialog = true;
              _this14.addingEntity.form = _objectSpread({}, defaultEntityAddForm);
              return _context13.abrupt("return", new Promise(function (resolve, reject) {
                _this14.resolve = resolve;
                _this14.reject = reject;
              }));
            case 4:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    close: function close() {
      if (!this.isAnyActionInProgress) {
        this.dialog = false;
        this.resetData();
        this.$emit("closed");
      }
    },
    resetData: function resetData() {
      this.addingEntity.form = _objectSpread({}, defaultEntityAddForm);
    },
    filterIntegerKey: filterIntegerKey,
    filterVAutocomplete: filterVAutocomplete
  }
};